/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'people.menu.renotify.flag.description': '全員にリマインダーを送信しています。この処理には数分かかる場合があります。',
  'people.menu.renotify.flag.description.confluence': 'チーム メイトにリマインド',
  'people.menu.renotify.flag.title': 'リマインダーを送信中',
  'people.menu.renotify.flag.title.confluence': '招待メールを再送します',
  'people.menu.renotify.menu.description':
    '{userCount, plural, other {{userCount,number} 人のユーザーが {product} への招待を受け入れていません。これらのユーザーを確認して、リマインダーを送ってください。}}',
  'people.menu.renotify.menu.description.confluence':
    'Confluence への招待を受諾していないユーザーがいます。それらのユーザーを確認してリマインダーを送信しましょう。',
  'people.menu.renotify.menu.dismiss': '閉じる',
  'people.menu.renotify.menu.dismiss.confluence': 'あとにする',
  'people.menu.renotify.menu.remind': 'チーム メンバーにリマインダーを送信',
  'people.menu.renotify.menu.remind.confluence': 'チーム メイトにリマインド',
  'people.menu.renotify.menu.title': '全員参加していますか?',
  'people.menu.renotify.modal.copied': 'リンクをコピーしました',
  'people.menu.renotify.modal.copy': '招待リンクをコピー',
  'people.menu.renotify.modal.description':
    '欠席のメンバーにメールでリマインダーを送ったり、自分で招待リンクを作成して共有したりできます。',
  'people.menu.renotify.modal.description.confluence': '招待メールを再送するか、招待リンクをコピーして共有します。',
  'people.menu.renotify.modal.dismiss': 'キャンセル',
  'people.menu.renotify.modal.resend': 'リマインダーを送信',
  'people.menu.renotify.modal.resend.confluence': '招待を再送',
  'people.menu.renotify.modal.title': '欠席のメンバーにリマインダーを送信',
  'people.menu.renotify.modal.title.confluence': '招待を受諾していないチーム メイトにリマインダーを送信する',
  'ptc.pm.collaborators.title': 'あなたのコラボレーター',
  'ptc.pm.error-heading': '問題が発生しました。',
  'ptc.pm.error-image-alt-text': '速やかに復旧するよう対応中です。',
  'ptc.pm.error-text': 'これらのエラーは監視していますが、更新しても問題が解決しない場合はご遠慮なくお知らせください。',
  'ptc.pm.num-members': '{memberCount, plural, other {{memberCount,number} 人のメンバー}}',
  'ptc.pm.people': 'ユーザー',
  'ptc.pm.teams': 'チーム',
  'ptc.pm.view-your-profile': 'プロフィールを表示',
  'ptc.pm.your-teams.title': 'あなたのチーム',
};
